export class ConversionClient {
	clientName: string;
	clientKeys: number[];
	clientCount: number;
	clientNos: string;
	winFactorIds: string;
	debtorCount: number;
	missingDebtorCount: number;
	invoiceCount: number;
	openInvoiceCount: number;
	openInvoiceBalance: number;
	/** FactorCloud.TermsLookup transfer term, or 'NO TERMS' when there is no row (the conversion then uses NEW SYSTEM TRANSFER). */
	termName: string;
	/** Set once Part 1 has run; the invoices are then imported into FactorCloud by hand before Part 2. */
	conversionPart1CompletedDate: string;
	/** Set once the carrier finished Part 2 (Converted tab). */
	conversionCompletedDate: string;
	/** Set when a converted carrier was reopened (shown in the Converted status tooltip). */
	conversionReopenedDate: string;

	/** UI only - not returned by the API. */
	selected?: boolean;

	/** UI only - migration progress for this row. */
	migrating?: boolean;
	/** Pending, Running, Part 1 Done, Migrated or Failed. */
	migrationStatus?: string;
	migrationSummary?: string;
}



// WEBPACK FOOTER //
// ./src/app/portal/conversion/models/ConversionClient.ts